import React, { Component } from 'react'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import AboutPageUI from './AboutPageUI.js'

class AboutPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      about: null,
      messageList: null
    }
  }

  render() {
    return (
      <AboutPageUI
        context={this.props.context}
        about={this.state.about}
        messageList = {this.state.messageList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getContent(context)
    this.getMessages(context)
    document.body.classList.add('sdp')
  }

  getContent(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/contents/about_the_app/locale/${context.locale}`,
      cacheKey: CacheKeys.Contents('about', context.locale),
      callback: this.getContentCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getContentCallback = (response) => {
    console.log('-> GET', response.publicURL);
    fetch(response.publicURL)
    .then((response) => {
      return response.text()
    })
    .then((text) => {
      console.log('<- GET', response.publicURL, /*text*/);
      this.setState({about : text})
    })
  }

  getMessages(context) {
    let arr = [
      'c_about',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_about', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default AboutPageSF
